<template>
    <section class="pt-16 flex flex-col items-center justify-center">
      <section class="max-w-1440">
         <secondary-banner :landing="4" :withBorder="true" :Banner="Banner" class="w-full" />
      </section>
         <section class="bg-graydi flex flex-col items-center w-full mt-16 md:mt-50px xl:mt-80px ">
          <text-image-container :withBorder="false" :container="imageContainer" />
         </section>
    </section>
</template>
<script>
import SecondaryBanner from "../../../../v2/src/sections/SecondaryBanner.vue";
import TextImageContainer from "../../../../v2/src/sections/TextImageContainer.vue";

export default {
     metaInfo: {
        title: 'Telemedicina y Diabetes',
        titleTemplate: '%s - Dra Omidres Pérez!',
        content: 'Hagamos viral la salud con la Dra. Omidres Pérez',
        meta: [
            { name: 'Telemedicina y Diabetes con la Dra. Omidres Pérez',
                content: 'Hagamos viral la salud con la Dra. Omidres Pérez',
                description: 'Hagamos viral la salud con la Dra. Omidres Pérez',
                vmid: 'Hagamos viral la salud con la Dra. Omidres Pérez' }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true,

        }
    },
    components: {
    SecondaryBanner,
    TextImageContainer,

  },
  data: () => ({
    Banner: {
      title: 'Telemedicina y Diabetes 2022',
      text: 'La Telemedicina ha avanzado a pasos agigantados en los últimos meses, y aunque todas las áreas y servicios de salud pueden apalancarse de la salud digital para ayudar más y mejor a sus pacientes, son aquellos portadores de condiciones crónicas de salud, que por consiguiente ameritan seguimiento y control a largo plazo, han sido un grupo de especial atención y beneficio de su salud y calidad de vida, gracias al uso de la telemedicina. <br/><br/> Por esto, hemos organizado DIABETES Y TECNOLOGÍA: Juntas para optimizar el buen control, un webinar exclusivo donde mostraremos las potencialidades de la Telemedicina en una condición tan común y desafiante como es la diabetes.',
      formText: 'Lorem Ipsum is simply dummy text of the printing and types etting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s',
      formTitle: "Regístrate gratis",
      formButtonText:'Enviar',
      formTermsText:'Acepto los terminos y condiciones',
      submit:"",

      titleStyles:"max-w-84.75 md:max-w-126 font-semibold leading-11.5 md:leading-15",
      textStyles:"text-xm leading-22px text-blacky xl:max-w-133",
      formBntStyles:" py-12px lg:max-w-75  transition duration-500 ease-in-out bg-btn2 hover:bg-yellow-600",
      formTitleStyles: "text-left pl-8 text-l text-blacky",
      formStyles:"bg-form rounded-2.5",

      firstButton: false,
      displayFormText: false,
      withBorder: false,
      formBorder: false,
      inputsBoxShadow: false,
    },

    imageContainer: {
        title: 'POR ESTO TE INVITAMOS A PARTICIPAR DE ESTE WEBINAR GRATUITO E INTERACTIVO, DIABETES Y TECNOLOGÍA: JUNTAS PARA OPTIMIZAR EL BUEN CONTROL',
        subTitle:'El cual será Dictado por la Dra Omidres Pérez, Medico Especialista en Medicina Interna, Endocrinología y Metabolismo, Autora de libro Controlando la diabetes a un click, Directora del Diplomado Internacional de Telemedicina, y donde te aprenderás las estrategias que toda consulta de telemedicina en diabetes debe cumplir para lograr esos resultados esperados.' ,
        text: 'En el caso de la diabetes, una condición que afecta a más de 62 millones de personas en las Américas, es una estrategia de gran ayuda, ya que ha demostrado científicamente, trabajar de manera efectiva en mejorar puntos duros que son de gran importancia para estos pacientes, dentro de los cuales destacan:',
        
        firstItem: '-Disminuir los niveles de Hemoglobina glicosilada (HbA1c) sin riesgos. <br/>- Aumentar adherencia al tratamiento. <br/> - Optimizar el monitoreo de los parámetros metabólicos dinámicos y la toma de decisiones. <br/>- Acceso efectivo a la educación diabetológica. <br/>- Prevenir complicaciones y secuelas de la diabetes',
        secondItem: 'Para lograrlo, el equipo de salud y los pacientes deben estar en sintonía, y es el profesional de salud de vanguardia, innovador y comprometido con sus pacientes presentes y futuros, el encargado de liderar esta transformación digital en aras del buen control, logran un consultorio sin fronteras, efectivo y eficaz, demanera ética, legal, segura y accesible a muchos.',


        titleStyles:"text-big text-center leading-24px max-w-203.5",
        subTitleStyles:"text-center text-xm leading-22px text-blacky max-w-203.5 xl:max-w-243.5",
        textStyle:"text-center text-big leading-22px text-blacky font-medium max-w-203.5 xl:max-w-243.5",

        textItemStyles:"text-xm leading-24px text-blacky",

        Icon:'recurso_signos.svg',
        boxImg:"imageBox.webp",
        secondBoxImg:"ItemBox.webp",

        
    }
  }),
}
</script>